export const DRIVERS = 'DRIVERS';
export const DRIVER_COUNT = 'DRIVER_COUNT';
export const SELECTED_DRIVER = 'SELECTED_DRIVER';
export const APP_DRIVER_BUSY = 'APP_DRIVER_BUSY';
export const DRIVER_REAL_TIME = 'DRIVER_REAL_TIME';
